import axios from "axios";

const DATA_ATTR = 'data-account-cabinet-self-progress-profile';
const CLASS_PREFIX = 'account-cabinet-self-progress-profile';
const PLACEHOLDER_AVATAR = '/img/avatar-placeholder.png';

export function initPersonalAccountTabProgressProfile($container, _userData) {
    const $templateMain = document.querySelector(`[${DATA_ATTR}-template-main]`);
    let $instanceRoot = null; // корень для этого инстанса
    let userData = {};
    const UPDATE_URL = $container?.getAttribute?.('data-update-url') || '/api/user/profile';

    init();

    async function init() {
        if (!$templateMain) return;
        userData = _userData || {};
        renderMain();
    }

    function renderMain(){
        // клонируем шаблон в DocumentFragment
        const fragment = $templateMain.content.cloneNode(true);

        // создаём уникальный корень для этой копии и помещаем туда фрагмент
        $instanceRoot = document.createElement('div');
        $instanceRoot.classList.add(CLASS_PREFIX + '__instance');
        $instanceRoot.appendChild(fragment);

        // вставляем корень в контейнер (теперь элементы в DOM)
        $container.appendChild($instanceRoot);

        // теперь уже вешаем обработчики и выполняем инициализацию на элементах внутри $instanceRoot
        renderInputs($instanceRoot);
        renderSwitchers($instanceRoot);

        if (userData.avatar_url) {
            updateGlobalAvatar(userData.avatar_url);
        }

        document.dispatchEvent(new CustomEvent('account-cabinet:render-complete', {bubbles: true}));
    }

    function updateGlobalAvatar(url) {
        const $global = document.querySelector('[data-account-profile-avatar]');
        if (!$global || !url) return;
        if ($global.tagName.toLowerCase() === 'img') {
            $global.src = url;
        } else {
            $global.style.backgroundImage = `url(${url})`;
        }
    }

    function renderSwitchers(root = $instanceRoot) {
        if (!root) return;
        const $switchers = root.querySelectorAll(`[${DATA_ATTR}-switch]`);
        $switchers.forEach($switcher => {
            const type = $switcher.getAttribute('data-type');
            const isActive = Boolean(Number(userData[type]));
            toggleSwitcherVisual($switcher, isActive);

            $switcher.addEventListener('click', async (e) => {
                e.preventDefault();
                const currentlyActive = $switcher.classList.contains(CLASS_PREFIX + '__setting-switch--active');
                const newValue = currentlyActive ? 0 : 1;
                toggleSwitcherVisual($switcher, newValue);
                try {
                    await updateSetting(type, newValue);
                    userData[type] = newValue;
                } catch (error) {
                    console.error('Ошибка обновления настройки:', error);
                    alert('Ошибка при сохранении настройки');
                    toggleSwitcherVisual($switcher, currentlyActive ? 1 : 0);
                }
            });
        });
    }

    function toggleSwitcherVisual($switcher, active) {
        if (active) {
            $switcher.classList.add(CLASS_PREFIX + '__setting-switch--active');
        } else {
            $switcher.classList.remove(CLASS_PREFIX + '__setting-switch--active');
        }
    }

    async function updateSetting(field, value) {
        const payload = { [field]: value };
        const response = await axios.post(UPDATE_URL, payload);
        if (!response || !response.data || !response.data.user) {
            throw new Error('Некорректный ответ от сервера');
        }
        return response.data.user;
    }

    function renderInputs(root = $instanceRoot) {
        if (!root) return;
        const $profileItems = root.querySelectorAll(`[${DATA_ATTR}-content]`);
        if (!$profileItems || $profileItems.length === 0) {
            console.debug('Нет элементов профиля для инициализации в', root);
            return;
        }

        $profileItems.forEach($profileItem => {
            const type = $profileItem.getAttribute('data-type');

            const $profileInput = $profileItem.querySelector(`[${DATA_ATTR}-input]`);
            const $profileText = $profileItem.querySelector(`[${DATA_ATTR}-text]`);
            const $profileBtn = $profileItem.querySelector(`[${DATA_ATTR}-change]`);

            // безопасные проверки — иногда шаблон может отличаться
            if (!$profileBtn) return;

            switch (type) {
                case 'img': {
                    const $imgPreview = $profileItem.querySelector(`[${DATA_ATTR}-text]`);
                    const $fileInput = $profileItem.querySelector(`input[${DATA_ATTR}-file]`);

                    // установим существующее фото
                    if ($imgPreview && userData.avatar_url) {
                        if ($imgPreview.tagName.toLowerCase() === 'img') {
                            $imgPreview.src = userData.avatar_url;
                        } else {
                            $imgPreview.style.backgroundImage = `url(${userData.avatar_url})`;
                        }
                    }

                    // клик по превью открывает input
                    if ($imgPreview && $fileInput) {
                        $imgPreview.style.cursor = 'pointer';
                        $imgPreview.addEventListener('click', () => $fileInput.click());
                    }

                    if (!$fileInput) {
                        console.debug('Файл-инпут не найден для превью (ожидалось атрибут', `${DATA_ATTR}-file)`);
                        break;
                    }

                    // сохраним оригинальный src для отката
                    $fileInput._originalSrc = ($imgPreview && $imgPreview.tagName.toLowerCase() === 'img') ? $imgPreview.src : (userData.avatar_url || PLACEHOLDER_AVATAR);

                    $fileInput.addEventListener('change', (e) => {
                        console.debug('input change event fired', e);
                        const file = e.target.files && e.target.files[0];
                        if (!file) {
                            console.debug('Файл не выбран или пользователь отменил диалог');
                            return;
                        }

                        // отзываем прошлый preview, если есть
                        if ($fileInput._previewUrl) {
                            try { URL.revokeObjectURL($fileInput._previewUrl); } catch (ignore) {}
                            $fileInput._previewUrl = null;
                        }

                        const url = URL.createObjectURL(file);
                        $fileInput._previewUrl = url;
                        console.debug('Создан preview URL', url);

                        if ($imgPreview) {
                            if ($imgPreview.tagName.toLowerCase() === 'img') {
                                $imgPreview.src = url;
                            } else {
                                $imgPreview.style.backgroundImage = `url(${url})`;
                            }
                        }

                        setToChange($profileItem);
                    });

                    break;
                }

                // остальные поля — без изменений логики
                case 'name':
                    if (userData.name) {
                        if ($profileInput) $profileInput.value = userData.name;
                        if ($profileText) $profileText.textContent = userData.name;
                    } else setToChange($profileItem);
                    break;

                case 'password':
                    if (userData.has_password) {
                        if ($profileInput) $profileInput.value = '';
                        if ($profileText) $profileText.textContent = '•••••••••••';
                    } else setToChange($profileItem);
                    break;

                case 'phone':
                    if (userData.phone) {
                        if ($profileInput) $profileInput.value = userData.phone;
                        if ($profileText) $profileText.textContent = userData.phone;
                    } else setToChange($profileItem);
                    break;

                case 'email':
                    if (userData.email) {
                        if ($profileInput) $profileInput.value = userData.email;
                        if ($profileText) $profileText.textContent = userData.email;
                    } else setToChange($profileItem);
                    break;

                case 'city':
                    if (userData.city) {
                        if ($profileInput) $profileInput.value = userData.city;
                        if ($profileText) $profileText.textContent = userData.city;
                    } else setToChange($profileItem);
                    break;
            }

            // поведение кнопки (защита на случай, если элемента нет)
            $profileBtn.addEventListener('click', async () => {
                try {
                    if (type === 'img') {
                        const $fileInputLocal = $profileItem.querySelector(`input[${DATA_ATTR}-file]`);
                        if ($profileBtn.classList.contains(CLASS_PREFIX + '__change--confirm')) {
                            await confirmChange($profileItem);
                        } else {
                            if ($fileInputLocal) {
                                $fileInputLocal.click();
                            } else {
                                setToChange($profileItem);
                            }
                        }
                    } else {
                        if ($profileBtn.classList.contains(CLASS_PREFIX + '__change--confirm')) {
                            await confirmChange($profileItem);
                        } else {
                            setToChange($profileItem);
                        }
                    }
                } catch (err) {
                    console.error(err);
                }
            });
        });
    }

    function setToChange($profileItem) {
        const $profileInput = $profileItem.querySelector(`[${DATA_ATTR}-input]`);
        const $profileText = $profileItem.querySelector(`[${DATA_ATTR}-text]`);
        const $profileBtn = $profileItem.querySelector(`[${DATA_ATTR}-change]`);

        $profileBtn.classList.add( CLASS_PREFIX + '__change--confirm');
        if ($profileInput) $profileInput.classList.add( CLASS_PREFIX + '__item-input--active');

        // Если это <img> — не прячем его (он превью). Вместо этого можно добавить класс для визуальной подсказки.
        if ($profileText) {
            if ($profileText.tagName && $profileText.tagName.toLowerCase() === 'img') {
                // опционально: подсветить превью, чтобы показать, что оно в режиме изменения
                $profileText.classList.add(CLASS_PREFIX + '__img--editing');
            } else {
                // это обычный текст — прячем
                $profileText.classList.add( CLASS_PREFIX + '__item-text--hide');
            }
        }

        $profileBtn.textContent = 'Подтвердить';
    }

    async function confirmChange($profileItem) {
        const $profileInput = $profileItem.querySelector(`[${DATA_ATTR}-input]`);
        const $profileText = $profileItem.querySelector(`[${DATA_ATTR}-text]`);
        const $profileBtn = $profileItem.querySelector(`[${DATA_ATTR}-change]`);

        const type = $profileItem.getAttribute('data-type');

        if ($profileBtn) {
            $profileBtn.disabled = true;
        }
        const prevBtnText = $profileBtn ? $profileBtn.textContent : 'Подтвердить';
        if ($profileBtn) $profileBtn.textContent = 'Сохраняем...';

        try {
            if (type === 'img') {
                const $fileInput = $profileItem.querySelector(`input[${DATA_ATTR}-file]`);
                if (!$fileInput || !$fileInput.files || !$fileInput.files[0]) {
                    throw new Error('Файл не выбран');
                }
                const file = $fileInput.files[0];
                await uploadImage(file, $profileItem);

                if ($fileInput && $fileInput._previewUrl) {
                    try { URL.revokeObjectURL($fileInput._previewUrl); } catch (ignore) {}
                    $fileInput._previewUrl = null;
                }
            } else {
                const fieldName = $profileItem.getAttribute('data-field') || type;
                const value = $profileInput ? $profileInput.value : null;
                if (value === null) throw new Error('Нет значения для отправки');
                await updateField(fieldName, value, $profileItem);
            }

            if ($profileBtn) $profileBtn.classList.remove( CLASS_PREFIX + '__change--confirm');
            if ($profileInput) $profileInput.classList.remove( CLASS_PREFIX + '__item-input--active');

            if ($profileText) {
                if ($profileText.tagName && $profileText.tagName.toLowerCase() === 'img') {
                    // убираем подсветку режима редактирования, если ставили
                    $profileText.classList.remove(CLASS_PREFIX + '__img--editing');
                } else {
                    $profileText.classList.remove( CLASS_PREFIX + '__item-text--hide');
                }
            }
            $profileBtn.classList.remove( CLASS_PREFIX + '__change--confirm');

            if ($profileBtn) $profileBtn.textContent = 'Изменить';
        } catch (err) {
            console.error(err);
            const errMsg = err?.response?.data?.message || err.message || 'Ошибка при сохранении';
            alert(errMsg);

            if (type === 'img') {
                const $fileInput = $profileItem.querySelector(`input[${DATA_ATTR}-file]`);
                const $imgPreview = $profileItem.querySelector(`[${DATA_ATTR}-text]`);
                const original = $fileInput && $fileInput._originalSrc ? $fileInput._originalSrc : (userData.avatar_url || PLACEHOLDER_AVATAR);
                if ($imgPreview) {
                    if ($imgPreview.tagName.toLowerCase() === 'img') {
                        $imgPreview.src = original;
                    } else {
                        $imgPreview.style.backgroundImage = `url(${original})`;
                    }
                }
                if ($fileInput) {
                    $fileInput.value = '';
                    if ($fileInput._previewUrl) {
                        try { URL.revokeObjectURL($fileInput._previewUrl); } catch (ignore) {}
                        $fileInput._previewUrl = null;
                    }
                }
            }

            setToChange($profileItem);
        } finally {
            if ($profileBtn) {
                $profileBtn.disabled = false;
                if (!$profileBtn.classList.contains(CLASS_PREFIX + '__change--confirm')) {
                    $profileBtn.textContent = 'Изменить';
                } else {
                    $profileBtn.textContent = prevBtnText;
                }
            }
        }
    }

    async function updateField(field, value, $profileItem) {
        const payload = { [field]: value };
        const response = await axios.post(UPDATE_URL, payload);
        if (response && response.data) {
            userData = { ...userData, ...response.data.user };
            const $profileText = $profileItem.querySelector(`[${DATA_ATTR}-text]`);
            if ($profileText) {
                if ($profileText.tagName && $profileText.tagName.toLowerCase() === 'img') {
                    // ничего не ставим в textContent; изображение для аватара обновляется через avatar_url/или uploadImage
                } else {
                    if (field === 'password') {
                        $profileText.textContent = '•••••••••••';
                    } else {
                        $profileText.textContent = value;
                    }
                }
            }
            if (response.data.user && response.data.user.avatar_url) {
                updateGlobalAvatar(response.data.user.avatar_url);
            }
        } else {
            throw new Error('Неудалось сохранить поле');
        }
    }

    async function uploadImage(file, $profileItem) {
        const $fileInput = $profileItem.querySelector(`input[${DATA_ATTR}-file]`);
        const $imgPreview = $profileItem.querySelector(`[${DATA_ATTR}-text]`);
        const originalSrc = ($imgPreview && $imgPreview.tagName.toLowerCase() === 'img') ? $imgPreview.src : null;

        const form = new FormData();
        form.append('avatar', file);

        const config = {
            headers: { 'Content-Type': 'multipart/form-data' },
        };

        const response = await axios.post(UPDATE_URL, form, config);

        if (response && response.data) {
            const newUser = response.data.user || {};
            if (newUser.avatar_url) {
                userData = { ...userData, ...newUser };
                if ($imgPreview) {
                    if ($imgPreview.tagName.toLowerCase() === 'img') {
                        $imgPreview.src = newUser.avatar_url;
                    } else {
                        $imgPreview.style.backgroundImage = `url(${newUser.avatar_url})`;
                    }
                }
                updateGlobalAvatar(newUser.avatar_url);
            } else {
                if ($imgPreview) {
                    if ($imgPreview.tagName.toLowerCase() === 'img') {
                        $imgPreview.src = originalSrc || PLACEHOLDER_AVATAR;
                    } else {
                        $imgPreview.style.backgroundImage = `url(${originalSrc || PLACEHOLDER_AVATAR})`;
                    }
                }
                throw new Error('Сервер не вернул ссылку на фото');
            }
        }
        else {
            if ($imgPreview) {
                if ($imgPreview.tagName.toLowerCase() === 'img') {
                    $imgPreview.src = originalSrc || PLACEHOLDER_AVATAR;
                } else {
                    $imgPreview.style.backgroundImage = `url(${originalSrc || PLACEHOLDER_AVATAR})`;
                }
            }
            throw new Error('Ошибка загрузки фото');
        }
    }
}
